import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Button,
  Typography,
  Space,
  message,
  Modal,
  Descriptions,
  Divider,
} from "antd";
import { GlobalOutlined, RightOutlined, ScanOutlined } from "@ant-design/icons";
import axios from "axios";
import { QRCodeCanvas } from "qrcode.react";

const { Text } = Typography;

const QRList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedQR, setSelectedQR] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleView = (record) => {
    setSelectedQR(record);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedQR(null);
  };

  const fetchQRList = async () => {
    setLoading(true);
    try {
      const authToken = localStorage.getItem("token") || "";
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/QR/link-to-qr`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setData(response.data.data || []);
    } catch (error) {
      message.error("Failed to fetch QR list");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQRList();
  }, []);

  const columns = [
    {
      title: "",
      dataIndex: "select",
      responsive: ["md"],
      width: 40,
      render: () => <input type="checkbox" style={{ marginLeft: 8 }} />,
    },
    {
      title: "Name",
      key: "title",
      responsive: ["xs", "sm", "md", "lg"],
      render: (_, record) => (
        <Space onClick={() => handleView(record)} style={{ cursor: "pointer" }}>
          <QRCodeCanvas value={record.link || record.qrText} size={48} />
          <div>
            <Text strong>{record.title}</Text>
          </div>
        </Space>
      ),
    },
    {
      title: "QR Type",
      key: "qrType",
      responsive: ["sm", "md"],
      align: "center",
      render: (record) =>
        record.link ? (
          <Tag icon={<GlobalOutlined />} color="blue">
            Link
          </Tag>
        ) : (
          <Tag icon={<ScanOutlined />} color="yellow">
            Text
          </Tag>
        ),
    },
    {
      title: "Created",
      dataIndex: "createdAt",
      responsive: ["md", "lg"],
      render: (input) => {
        const date = new Date(input.split(".")[0]);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    {
      title: "State",
      dataIndex: "status",
      responsive: ["sm", "md"],
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "",
      key: "view",
      responsive: ["xs", "sm", "md", "lg"],
      render: (record) => (
        <Button
          type="text"
          icon={<RightOutlined />}
          onClick={() => handleView(record)}
        />
      ),
    },
  ];

  return (
    <div style={{ padding: 12 }}>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowKey={(record) => record.key || record.id}
        scroll={{ x: "max-content" }}
      />

      {selectedQR && (
        <Modal
          title={selectedQR.title}
          open={isModalOpen}
          onCancel={handleClose}
          footer={null}
          width={Math.min(window.innerWidth - 40, 600)}
        >
          <Divider />
          <div style={{ textAlign: "center" }}>
            <QRCodeCanvas
              value={selectedQR.link || selectedQR.qrText}
              size={Math.min(window.innerWidth * 0.8, 300)}
              style={{ marginBottom: 16 }}
            />
            <Descriptions
              column={1}
              bordered
              size="middle"
              contentStyle={{ display: "flex", flexWrap: "wrap" }}
            >
              <Descriptions.Item label="QR Type">
                {selectedQR.link ? "Link" : "Text"}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {selectedQR.status}
              </Descriptions.Item>
              <Descriptions.Item label="Created">
                {new Date(selectedQR.createdAt.split(".")[0]).toLocaleString(
                  "en-US",
                  {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  }
                )}
              </Descriptions.Item>
              {selectedQR.link && (
                <Descriptions.Item label="Link">
                  <a
                    href={selectedQR.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {selectedQR.link}
                  </a>
                </Descriptions.Item>
              )}
              {!selectedQR.link && selectedQR.qrText && (
                <Descriptions.Item label="Text">
                  {selectedQR.qrText}
                </Descriptions.Item>
              )}
            </Descriptions>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default QRList;
